<template>
  <div class="van-de-graaff-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>V = Q / C | E = σ / ε₀$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Metal Dome -->
          <path d="M 150,80 A 50,50 0 1 1 250,80 Z" fill="#888" stroke="#ccc" stroke-width="2" />
          <circle cx="200" cy="80" r="50" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="5" />

          <!-- The Pillar -->
          <rect x="180" y="80" width="40" height="140" fill="rgba(255,255,255,0.05)" stroke="#555" />

          <!-- The Belt -->
          <rect x="190" y="90" width="20" height="120" fill="#444" rx="10" />
          <g v-if="running">
             <circle v-for="n in 6" :key="'q'+n" cx="200" :cy="90 + (n*20 + beltOffset)%120" r="3" fill="#ff4757">
                <animate attributeName="opacity" values="1;0.5;1" dur="0.5s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Charge Spark (Random flash) -->
          <path v-if="sparking" :d="sparkPath" fill="none" stroke="#00d2ff" stroke-width="2" />

          <!-- Human Hand (Approaching) -->
          <g :transform="`translate(${300 - proximity}, 100)`">
             <rect x="0" y="0" width="40" height="10" fill="#e0ac69" rx="5" />
             <text x="10" y="25" fill="#888" font-size="8">靠近受试物</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>表面电荷密度: {{ chargeDensity.toFixed(1) }} μC/m²</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button :type="running ? 'danger' : 'success'" size="mini" @click="running = !running">
               {{ running ? '停止电机' : '开启点击' }}
             </el-button>
             <el-button size="mini" @click="flashSpark" :disabled="chargeDensity < 50">放电</el-button>
          </div>
          <div class="row items-center">
             <label>调节距离</label>
             <el-slider v-model="proximity" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>范德格拉夫起电机通过传送带将电荷源源不断地输送到金属球壳表面。由于同种电量相互排斥，电荷会堆积在球壳外表面。通过这种方式可以产生高达**数百万伏**的静电高压，常用于粒子加速和演示静电排斥（如怒发冲冠）。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VanDeGraaffViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      running: true,
      beltOffset: 0,
      chargeDensity: 0,
      proximity: 0,
      sparking: false,
      sparkPath: "",
      timer: null
    }
  },
  methods: {
    flashSpark() {
      this.sparking = true;
      let x1 = 250;
      let y1 = 80;
      let x2 = 300 - this.proximity;
      let y2 = 100;
      this.sparkPath = `M ${x1} ${y1} L ${x1+10} ${y1+5} L ${x1+5} ${y1+10} L ${x2} ${y2}`;
      setTimeout(() => { this.sparking = false; this.chargeDensity = 0; }, 100);
    },
    update() {
      if (this.running) {
        this.beltOffset = (this.beltOffset + 2) % 120;
        if (this.chargeDensity < 100) this.chargeDensity += 0.2;
      }
      // Auto spark if too close and charged
      if (this.chargeDensity > (150 - this.proximity) && !this.sparking) {
        this.flashSpark();
      }
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.van-de-graaff-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
